export default __webpack_public_path__ + "static/media/case-study-2-fleetview-submarine.003ea2a7.mp4";